import { SVGAttributes } from 'react';
import * as React from 'react';

export const OverdueUploadIcon = ({ color, ...rest }: SVGAttributes<SVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4855 20.4853C20.8751 20.8749 20.8758 21.5065 20.4876 21.8974C20.0975 22.2903 19.462 22.2918 19.0705 21.9003L17.1701 20H6.00013C5.44785 20 5.00013 19.5522 5.00013 19C5.00013 18.4477 5.44785 18 6.00013 18H15.1701L13.1701 16H10.0001C9.44785 16 9.00013 15.5522 9.00013 15V11.83L7.17013 9.99995H6.54163C5.97278 9.99995 5.6879 9.31219 6.09013 8.90995L2.10126 4.92956C1.70904 4.53818 1.70984 3.90249 2.10302 3.51209C2.49394 3.12392 3.1252 3.12502 3.51475 3.51457L20.4855 20.4853ZM16.5864 9.99995H15.0006V12.17L8.91064 6.08995L11.2935 3.70706C11.6841 3.31654 12.3172 3.31654 12.7077 3.70706L17.2935 8.29285C17.9235 8.92281 17.4773 9.99995 16.5864 9.99995Z"
        fill={color}
      />
    </svg>
  );
};
